export default {
  addressListGetter(state) {
    return state.addressList.data.map((item) => {
      const addressPart = item.addressPart.split('/') || [];
      const [province, city, address] = addressPart;
      return {
        province,
        city,
        address,
        ...item,
      };
    });
  },
};
